import classNames from 'classnames'
import { useEffect } from 'react'

import { type IChildServiceDec, type IServiceDec } from '@App/types/servicesTypes'

import style from './SectionsForChose.module.scss'

interface IProps {
    category: IServiceDec
    tranferredService: IChildServiceDec
    chosen: IServiceDec | null
    setChosen: (chosen: IServiceDec | null) => void
}

const onGetUnitedList = (list: IServiceDec[]): IServiceDec[] => {
    const result = []
    for (let i = 0; i <= list.length - 1; i++) {
        const item = list[i]
        if (list[i].childCategories.length > 0) {
            result.push(...onGetUnitedList(list[i].childCategories))
        }
        result.push(item)
    }
    return result
}

export const SectionsForChose = (props: IProps) => {
    const { category, setChosen, chosen } = props

    const allSections = onGetUnitedList(category.childCategories)

    useEffect(() => {
        if (category.childCategories.length < 1) {
            setChosen(category)
        }
    }, [category, setChosen])

    return (
        <div className={style.container}>
            {allSections.length > 0 ? (
                allSections
                    .filter((item) => item.childCategories.length < 1)
                    .map((el) => {
                        const { id, name } = el
                        const cn = classNames(style.title, chosen && id === chosen.id && style.chosenTitle)
                        return (
                            <div key={id} className={cn} onClick={() => setChosen(el)}>
                                <span>{name}</span>
                            </div>
                        )
                    })
            ) : (
                <div className={style.emptySections}>
                    <span>{`Разделы отсутствуют, можно перенести прямо в категорию ${category.name}`}</span>
                </div>
            )}
        </div>
    )
}
